import { FC } from 'react';

interface NavbarListItemProps {
  item: {
    label: string;
    title?: string;
    path?: string;
    blank?: boolean;
  }
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const NavbarListItem: FC<NavbarListItemProps> = ({ item, setIsOpen }) => {
  return (
    <li key={item.label} className="relative lg:rounded-md block p-2 lg:p-1 lg:py-3 font-medium text-md lg:text-sm xl:text-base lg:inline-block lg:text-center">
      <a
        href={item.path}
        title={item.title}
        target={item.blank ? "_blank" : "_self"}
        rel="noreferrer"
        className=""
        onClick={() => setIsOpen(false)}
      >
        {item.label}
      </a>
    </li>
  )
};